import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function TempoIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 4H7.5A2.5 2.5 0 0 0 5 6.5v12A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5v-12A2.5 2.5 0 0 0 16.5 4H15" />
        <path d="M10 2.5h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1Z" />
        <path d="M12 13.68C10.2 12.56 9.27 11.51 9.27 10.39C9.27 9.59 9.89 9.03 10.64 9.03C11.26 9.03 11.75 9.4 12 9.9C12.25 9.4 12.74 9.03 13.36 9.03C14.11 9.03 14.73 9.59 14.73 10.39C14.73 11.51 13.8 12.56 12 13.68Z" />
        <path d="M9 16.5h6" />
      </g>
    </SvgIcon>
  );
}
